//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "productCertificateAdd",
  components: {
  },
  data() {
    return {
      showPicker:false,
      color:'',
      tel:'',
      purchaseId:'',
      showPicker: false,
      columns: ['红色', '黄色', '蓝色'],
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onConfirm(value) {
      this.color = value;
      this.showPicker = false;
    },
    toEdit(){
      this.$router.push({name:'productCertificateEdit'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/productCertificates/add.vue